<template>
  <footer class="site-section site-footer">
    <div class="footer-container">
      <div class="footer-top-grid">
        <div class="footer-grid-item">
          <router-link :to="{ name: 'home' }">
            <img
              src="@/assets/img/svg/white_logo.svg"
              width="235"
              class="logo"
            />
          </router-link>
        </div>
        <nav class="footer-grid-item">
          <h4>Institucional</h4>
          <ul>
            <li
              v-for="(item, index) in institutional_links"
              :key="`i-link-${index}`"
            >
              <router-link :to="item.to">{{ item.name }}</router-link>
            </li>
          </ul>
        </nav>
        <nav class="footer-grid-item">
          <h4><router-link :to="{ name: 'blog' }">Diké</router-link></h4>
          <ul>
            <li v-for="(item, index) in categories" :key="`i-link-${index}`">
              <router-link
                :to="{ name: 'category', params: { category: item.slug } }"
                >{{ item.name }}</router-link
              >
            </li>
          </ul>
        </nav>
        <div class="footer-grid-item">
          <h4>Redes Sociais</h4>
          <social-networks icon-width="35" icon-fill="#fff" />
          <span class="flex-1"></span>
          <h4>ASSINE NOSSA NEWSLETTER</h4>
          <div class="input">
          <input type="email" placeholder="Digite seu e-mail" ref="email" />
          <a class="control text-orange" v-on:click="submitEmail()">
            <div>ENVIAR <arrow-horizontal width="18" /></div>
          </a>
        </div>
        </div>
      </div>
      <div class="footer-middle-grid">
        <div
          class="footer-grid-item"
          v-for="(item, index) in addresses"
          :key="`address-item-${index}`"
        >
          <h5>{{ item.title }}</h5>
          <p>{{ item.text }}</p>
        </div>
      </div>
      <div class="footer-bottom-grid">
        <div>Política de Privacidade.</div>
        <div>
          Copyright © 2020 Crivelli Advogados Associados. Todos os direitos
          reservados
        </div>
      </div>

       <modal :active.sync="modalContactIsOpen">
        <div class="text-center">
          <h3>E-mail cadastrado com sucesso!</h3>
        </div>
      </modal>
    </div>
  </footer>
</template>

<script>
import ArrowHorizontal from "@/components/Svg/ArrowHorizontal.vue";
import SocialNetworks from "@/components/SocialNetworks";
import api from "../services/api";
import Modal from "@/components/Modal";

export default {
  components: {
    ArrowHorizontal,
    SocialNetworks,
    Modal,
  },

  computed: {
    institutional_links() {
      return [
        { name: "Home", to: { name: "home" } },
        // {name: 'Blog Jurídico', to: {name: 'blog_posts'}},
        { name: "Áreas de Atuação", to: { name: "page_expertise_area" } },
        { name: "Sobre Nós", to: { name: "page_about" } },
        { name: "Equipe", to: { name: "page_team" } },
        { name: "Trabalhe Conosco", to: { name: "page_work_with_us" } },
        { name: "Contato", to: { name: "page_contact" } },
        { name: "Agendamento Online", to: { name: "page_online_scheduling" } },
      ];
    },

    blog_links() {
      return [{ name: "Notícias", to: { name: "news" } }];
    },

    addresses() {
      return [
        {
          title: "São Paulo",
          text:
            "Rua Boa Vista, 254, 12º andar, Cj. 1209\nCentro - CEP 01014.000 - São Paulo/SP\nTel.: (11) 3376.0100",
        },
        {
          title: "Brasília",
          text:
            "SAUS Quadra 5 Bloco K, SALA 903-904, Cj. 11\nAsa Sul - CEP 70070.050 - Brasília/DF\nTel.: (61) 3323.4924",
        },
        {
          title: "Ribeirão Preto",
          text:
            "Av. Presidente Vargas, 2121, Cj. 2302, Sala 09\nSanta Angela - CEP 14020.260 - Ribeirão Preto/SP\nTel.: (16) 3602.8494",
        },
        {
          title: "Osasco",
          text:
            "R. Presidente Castelo Branco, 45, Salas 709/710\nCentro - CEP 06013.070 - Osasco/SP\nTel.: (11) 4620.0644",
        },
      ];
    },
  },
  data() {
    return {
       modalContactIsOpen: false,
      categories: [
        { name: "Artigos", id: 1, slug: "artigos" },
        { name: "Vídeos", id: 2, slug: "videos" },
        { name: "Podcast", id: 3, slug: "podcast" },
        { name: "Eventos", id: 4, slug: "eventos" },
      ],
    };
  },

  methods: {
    async submitEmail() {
      const email = this.$refs.email.value;
      if(email)
      {
          await api.post(`newsletter?email=${email}`);
          this.modalContactIsOpen = true;
           this.$refs.email.value = '';
      }
    },
  }
};
</script>

<style>
</style>
